import deepFreeze from "deep-freeze-es6";

import { Measurand, Symbol } from "../../domain";

export type Channel = Readonly<{
  sourceUri: string;
  measurand: Measurand;
}>;
export type AmbiguousChannel = Readonly<{
  sourceUri: string;
  symbol: Symbol;
}>;
export type MeasuringDevice = Readonly<{
  channels: Array<Channel>;
  ambiguousChannels: Array<AmbiguousChannel>;
  label: string;
  edgeDeviceId: string;
}>;
export function makeChannel(sourceUri: string, measurand: Measurand): Channel {
  return deepFreeze({ sourceUri, measurand });
}
export function makeAmbiguousChannel(sourceUri: string, symbol: Symbol): AmbiguousChannel {
  return deepFreeze({ sourceUri, symbol });
}
export function makeMeasuringDevice(
  label: string,
  edgeDeviceId: string,
  channels: Array<Channel>,
  ambiguousChannels: Array<AmbiguousChannel> = []
): MeasuringDevice {
  return deepFreeze({ label, edgeDeviceId, channels, ambiguousChannels });
}
